<template>
  <div class="article" ref="detail">
    <gm-share class="share" v-if="closeBtn && article.title" />
    <div class="detail">
      <template v-if="!hasTitle">
        <h3 class="title">{{ article.title }}</h3>
        <p class="publish">
          <span class="date">
            <template v-if="article.published_at">{{ $t('published') }}{{ article.published_at }}</template>
          </span>
          <span v-show="!isMC" class="view">{{ $t('read') }} {{ article.view_count || 0 }}</span>
        </p>
      </template>
      <div class="article-content">
        <div v-html="content"></div>
      </div>
    </div>
    <transition name="fade" v-if="showCustom">
      <custom-service v-show="status" :article="article"></custom-service>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import native, { isMC } from '@/utils'
import GmShare from '@/components/Share'
import CustomService from '../components/LikeService'

const getKeys = (name) => {
  const { search } = location
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = search.slice(1).match(reg)
  if (r != null) return unescape(decodeURI(r[2]))
  return null
}
const { appInfo } = native

export default {
  name: 'detail',
  computed: {
    ...mapGetters({
      article: 'getArticle',
    }),
    showCustom() {
      const user = navigator.userAgent
      const bool =
        (user.indexOf('Version') > -1 &&
          user.indexOf('Linux') > -1 &&
          user.indexOf('MicroMessenger') === -1 &&
          user.indexOf('AliApp') === -1) ||
        (user.indexOf('iPhone') > -1 &&
          user.indexOf('Version') === -1 &&
          user.indexOf('MicroMessenger') === -1 &&
          user.indexOf('AliApp') === -1)
      return !isMC() && bool && !!(appInfo.key || appInfo.token)
    },
    content() {
      const con = (this.article.content || '').replace(
        /<video/g,
        '<video poster="/storage/images/2018/10/18/qPRhJMCDzF49kkusFuQkjncbfV66ZcbJFOFr8AJ3.png"'
      )
      if (process.env.NODE_ENV === 'production') {
        return con
      }
      return (con || '').replace(
        /\/storage/g,
        'https://help-cms.duoke.net/storage'
      )
    },
    dkshare() {
      return !this.$route.query.dkshare && !getKeys('dkshare')
    },
    isMC() {
      return isMC
    },
    hasTitle() {
      return !!(appInfo.key || appInfo.token) && appInfo.dkshare
    },
  },
  components: {
    GmShare,
    CustomService,
  },
  data() {
    return {
      shareBtn: true,
      status: true,
      scrollTop: 0,
    }
  },
  mounted() {
    this.closeBtn = !!(appInfo.key || appInfo.token) && !appInfo.dkshare
    const id = (this.$route.query.id || '').toString()
    if (this.id !== id) {
      this.id = id
      this.$store.dispatch('requestData', {
        method: 'article',
        payload: {},
      })
      this.$store.dispatch('requestArticle', { id })
    }
    this.status = true
    // 通过$refs获取dom元素
    const box = this.$refs.detail
    // 监听这个dom的scroll事件
    box.addEventListener(
      'scroll',
      () => {
        if (this.scrollTop !== box.scrollTop) {
          this.status = this.scrollTop > box.scrollTop
          this.scrollTop = box.scrollTop
        }
      },
      false
    )
  },
}
</script>

<style lang="scss" scoped>
@import '../../../style/func.scss';

.light .article .share {
  color: #000;
}
.article {
  .share {
    position: fixed;
    right: 0;
    top: 0;
    width: px2rem(48px);
    color: #fefefe;
    height: px2rem(40px);
    font-size: px2rem(24px);
    text-align: center;
    line-height: px2rem(42px);
    z-index: 10;
  }
}
.iPhone {
  .article {
    .share {
      top: 20px;
      top: constant(safe-area-inset-top);
      top: env(safe-area-inset-top);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help-center/views/AnswerView.vue